import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ModalOpcionesImpresion from '../components/impresion/ModalOpcionesImpresion';
import '../styles/Clientes.css';

const PorRecoger = () => {
  const [prestamos, setPrestamos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { codigo } = useParams();

  // Estados para opciones de impresión
  const [mostrarModalImpresion, setMostrarModalImpresion] = useState(false);
  const [opcionesImpresion, setOpcionesImpresion] = useState(null);

  // Función para construir rutas con el código del tenant
  const getRoute = (path) => {
    return codigo ? `/${codigo}${path}` : path;
  };

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      setError('');

      // Usar el nuevo endpoint que incluye opciones de impresión
      const response = await fetch('/api/reportes/deben-pagar-hoy', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error('Error al cargar los datos');
      }

      const data = await response.json();
      setPrestamos(data.prestamos || []);

      // Guardar las opciones de impresión
      if (data.opciones_impresion) {
        setOpcionesImpresion(data.opciones_impresion);
      }

      // Obtener todos los préstamos activos (código legacy como respaldo)
      // const response = await prestamoService.getPrestamos({ estado: 'activo', per_page: 1000 });
      // const todosPrestamos = response.data.prestamos || [];

      // Los datos ya vienen filtrados desde el backend
      // setPrestamos(data.prestamos || []);

    } catch (err) {
      console.error('Error:', err);
      setError(err.response?.data?.error || 'Error al cargar los datos');
    } finally {
      setLoading(false);
    }
  };

  const formatMoney = (amount) => {
    return `$${Math.round(amount || 0).toLocaleString('es-DO')}`;
  };

  const generarPDF = () => {
    const doc = new jsPDF();
    const fechaActual = new Date().toLocaleDateString('es-DO', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    // Título
    doc.setFontSize(16);
    doc.setTextColor(41, 128, 185);
    doc.text('INVERSIONES RAMIREZ', 105, 15, { align: 'center' });

    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text('Préstamos Que Deben Pagar', 105, 25, { align: 'center' });

    // Información de fecha y totales
    doc.setFontSize(10);
    doc.text(`Fecha: ${fechaActual}`, 14, 35);
    doc.text(`Total Préstamos: ${prestamos.length}`, 14, 42);
    doc.text(`Total Abiertos: 0`, 14, 49);
    doc.text(`Total Cerrados: ${prestamos.length}`, 14, 56);

    // Tabla de préstamos cerrados
    const prestamosCerrados = prestamos.map((prestamo, index) => {
      const cuotaDiaria = prestamo.total / prestamo.cuotas;
      const cuotaActual = prestamo.cuotas_pagadas + 1;

      return [
        prestamo.id,
        `${prestamo.cliente?.nombres || ''} ${prestamo.cliente?.apellidos || ''}`,
        `${prestamo.modalidad}\nNúmero: ${cuotaActual}`,
        Math.round(cuotaDiaria),
        Math.round(prestamo.total),
        prestamo.cliente?.negocio || prestamo.cliente?.direccion || ''
      ];
    });

    autoTable(doc, {
      startY: 65,
      head: [['Prestamo', 'Cliente', 'Nro', 'Cuota', 'A Saldar', 'Negocio']],
      body: prestamosCerrados,
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontSize: 10,
        fontStyle: 'bold'
      },
      bodyStyles: {
        fontSize: 9
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240]
      },
      margin: { left: 14, right: 14 }
    });

    // Total al final
    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(10);
    doc.text(`Total: ${Math.round(totalPorRecoger)}`, 14, finalY);

    // Resumen de préstamos
    doc.text('Resumen Préstamos', 14, finalY + 15);
    doc.text(`Abiertos Pagar Hoy: 0`, 14, finalY + 22);
    doc.text(`Abiertos Sin Pagar: 0`, 14, finalY + 29);
    doc.text(`Cerrados: ${Math.round(totalPorRecoger)}`, 14, finalY + 36);
    doc.text(`Total: ${Math.round(totalPorRecoger)}`, 14, finalY + 43);

    // Pie de página
    const pageCount = doc.internal.getNumberOfPages();
    doc.setFontSize(8);
    doc.setTextColor(128, 128, 128);
    doc.text(
      `Fecha reporte: ${new Date().toLocaleDateString('es-DO')} ${new Date().toLocaleTimeString('es-DO')}`,
      14,
      doc.internal.pageSize.height - 10
    );
    doc.text(
      `Página 1 de ${pageCount}`,
      doc.internal.pageSize.width - 30,
      doc.internal.pageSize.height - 10
    );

    // Guardar PDF
    const nombreArchivo = `INVERSIONES RAMIREZ - Préstamos Que Deben Pagar_${new Date().toLocaleDateString('es-DO').replace(/\//g, '')}_${new Date().toLocaleTimeString('es-DO').replace(/:/g, '')}.pdf`;
    doc.save(nombreArchivo);
  };

  // Calcular total por recoger (solo la cuota de HOY)
  const totalPorRecoger = prestamos.reduce((sum, prestamo) => {
    const cuotaDiaria = prestamo.total / prestamo.cuotas;
    return sum + cuotaDiaria;
  }, 0);

  if (loading) return <div className="loading">Cargando...</div>;

  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>Por Recoger</h1>
        <div style={{display: 'flex', gap: '1rem'}}>
          <button
            className="btn"
            onClick={generarPDF}
            style={{background: '#3498db', color: '#fff'}}
          >
            📄 Generar Reporte
          </button>
          <button
            className="btn"
            onClick={() => setMostrarModalImpresion(true)}
            style={{background: '#e67e22', color: '#fff'}}
            disabled={!opcionesImpresion}
          >
            🖨️ Opciones de Impresión
          </button>
          <button
            className="btn"
            onClick={() => navigate(getRoute('/dashboard'))}
            style={{background: '#666', color: '#fff'}}
          >
            ← Volver al Dashboard
          </button>
        </div>
      </div>

      {error && <div className="banner error">{error}</div>}

      {/* Resumen */}
      <div className="card" style={{marginBottom: '2rem', background: '#e67e22', color: '#fff', padding: '2rem', textAlign: 'center'}}>
        <h2 style={{margin: 0}}>Total Por Recoger</h2>
        <div style={{fontSize: '2.5rem', fontWeight: 'bold', marginTop: '1rem'}}>
          {formatMoney(totalPorRecoger)}
        </div>
        <div style={{marginTop: '0.5rem', opacity: 0.9}}>
          {prestamos.length} préstamo{prestamos.length !== 1 ? 's' : ''} activo{prestamos.length !== 1 ? 's' : ''}
        </div>
      </div>

      {/* Tabla de préstamos */}
      <div className="card">
        <div className="card-title" style={{background: '#e67e22'}}>
          Detalle de Préstamos Activos
        </div>

        <p style={{padding: '1rem'}}>
          Mostrando registros del 1 al {prestamos.length} de un total de {prestamos.length} registros
        </p>

        <div className="table-actions">
          <button className="btn">📄 Excel</button>
          <button className="btn">📋 Copiar</button>
          <button className="btn">🖨️ Imprimir</button>
          <button className="btn">👁️ Visibilidad de columnas</button>
        </div>

        {prestamos.length === 0 ? (
          <p style={{padding: '1rem', textAlign: 'center', color: '#666'}}>
            No hay préstamos activos
          </p>
        ) : (
          <div style={{overflowX: 'auto'}}>
            <table className="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Cliente</th>
                  <th>Monto Total</th>
                  <th>Pagado</th>
                  <th>Por Recoger</th>
                  <th>Cuotas Pagadas</th>
                  <th>Cuotas Totales</th>
                  <th>% Completado</th>
                  <th>Tipo</th>
                </tr>
              </thead>
              <tbody>
                {prestamos.map((prestamo) => {
                  const cuotaDiaria = prestamo.total / prestamo.cuotas;
                  const pagadoHastaAyer = cuotaDiaria * prestamo.cuotas_pagadas;
                  const cuotaActual = prestamo.cuotas_pagadas + 1; // Cuota que se debe cobrar HOY
                  const porcentaje = ((prestamo.cuotas_pagadas / prestamo.cuotas) * 100).toFixed(1);

                  return (
                    <tr key={prestamo.id}>
                      <td>{prestamo.id}</td>
                      <td>
                        {prestamo.cliente?.nombres || ''} {prestamo.cliente?.apellidos || ''}
                      </td>
                      <td>{formatMoney(prestamo.total)}</td>
                      <td style={{color: '#27ae60', fontWeight: 'bold'}}>{formatMoney(pagadoHastaAyer)}</td>
                      <td style={{color: '#e67e22', fontWeight: 'bold'}}>{formatMoney(cuotaDiaria)}</td>
                      <td>{cuotaActual}</td>
                      <td>{prestamo.cuotas}</td>
                      <td>
                        <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                          <div style={{
                            flex: 1,
                            height: '8px',
                            background: '#f0f0f0',
                            borderRadius: '4px',
                            overflow: 'hidden'
                          }}>
                            <div style={{
                              width: `${porcentaje}%`,
                              height: '100%',
                              background: porcentaje < 50 ? '#e74c3c' : porcentaje < 80 ? '#e67e22' : '#27ae60',
                              transition: 'width 0.3s'
                            }}></div>
                          </div>
                          <span style={{fontSize: '0.85rem', color: '#666'}}>{porcentaje}%</span>
                        </div>
                      </td>
                      <td>
                        <span className={`badge ${prestamo.tipo === 'capital_final' ? 'badge-warning' : 'badge-success'}`}>
                          {prestamo.tipo === 'capital_final' ? 'Capital Final' : 'Amortizado'}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal de opciones de impresión */}
      <ModalOpcionesImpresion
        isOpen={mostrarModalImpresion}
        onClose={() => {
          setMostrarModalImpresion(false);
        }}
        opciones={opcionesImpresion?.opciones || []}
        titulo="Opciones de Impresión - Deben Pagar Hoy"
        onOpcionSeleccionada={(opcion) => {
          console.log('Opción seleccionada:', opcion.nombre);
          setTimeout(() => {
            setMostrarModalImpresion(false);
          }, 2000);
        }}
      />
    </div>
  );
};

export default PorRecoger;
